import { render, staticRenderFns } from "./contactInformation.vue?vue&type=template&id=89c96158&"
import script from "./contactInformation.vue?vue&type=script&lang=js&"
export * from "./contactInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports